import { useDeviceStore } from '@namespace/device';
import { Language as CoreLanguage } from '@namespace/layout';

const Language = ({ id }) => {
  const { isDesktop } = useDeviceStore();

  return <CoreLanguage id={id} isFooter={!isDesktop} />;
};

export default Language;
